<div id="google-address-search" class="google-address-search container">
  <form [formGroup]="SearchFG" (ngSubmit)="{}">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'section-user.connected.address' | translate }}</mat-label>
      <input
        #googleMapsAutocomplete
        id="googleMapsAutocomplete"
        class="google-address-search input"
        matInput
        formControlName="searchString"
        type="text"
        [autofocus]="true"
      />
    </mat-form-field>
  </form>
</div>
